let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aZinD"), load("3JWH2"), load("hvHZS")]).then(() => parcelRequire('5QLLH'));